import React from "react";
import "./TrustSupportSection.css";
import { Link } from "react-router-dom";
const TrustSupportSection = () => {
  return (
    <div className="trust-cta-main">
      {/* ===== Trust Section ===== */}
      <div className="trust-section">
        <h1 className="trust-heading">Trust and Support</h1>

        <ul className="trust-list">
          <li>24×7 Support</li>
          <li>Verified Partners</li>
          <li>Transparent Pricing</li>
          <li>No Hidden Charges</li>
        </ul>
      </div>

      {/* ===== CTA Section ===== */}
      <div className="cta-section">
        <h1 className="cta-heading">Final Call To Action</h1>
        <p className="cta-sub">Travel Your Way with ZikRme</p>

        <div className="cta-buttons">
          <Link to="/tour-package-view-more">
            <button>Explore Tour</button>
          </Link>
          <Link to="/travel-panning">
            <button>Build Custom Trip</button>
          </Link>
          <Link to="/guidance-page">
            <button>Guidance</button>
          </Link>
          <Link to="/request-call-back">
            <button>Request Call Back</button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TrustSupportSection;
